import React from 'react';

import { Card } from '@repo/ui/Card';
import { QuickLinks } from '@repo/ui/QuickLinks';
import { QuickLinkType } from '@repo/ui/QuickLinks';
import { useUser } from '@repo/hooks/useUser';
import { POLICIES } from '@/lib/Authorization';

import { Link, useParams } from 'react-router';

const HomeQuickLinks = () => {
  const user = useUser();

  const params = useParams();
  const { accountId } = params;

  const links: (QuickLinkType | null)[] = [
    POLICIES['sms_requests:index'](user)
      ? {
          title: 'Messaging',
          description: 'View your message details.',
          icon: 'SMS',
          href: `/a/${accountId}/messaging`,
          as: Link,
        }
      : null,
    POLICIES['dids:index'](user)
      ? {
          title: 'Numbers',
          description: 'View all your numbers.',
          icon: 'tag',
          href: `/a/${accountId}/numbers`,
          as: Link,
        }
      : null,

    POLICIES['csp_brands:index'](user)
      ? {
          title: 'TCR Brands',
          description: 'View your registered 10DLC brands.',
          icon: 'corporate_fare',
          href: `/a/${accountId}/tcr/brands`,
          as: Link,
        }
      : null,
    POLICIES['csp_campaigns:index'](user)
      ? {
          title: 'TCR Campaigns',
          description: 'View your registered 10DLC campaigns.',
          icon: 'campaign',
          href: `/a/${accountId}/tcr/campaigns`,
          as: Link,
        }
      : null,

    POLICIES['messaging_auto_responses:index'](user)
      ? {
          title: 'Auto Responders',
          description: 'View and modify auto responders.',
          icon: 'quickreply',
          href: `/a/${accountId}/auto-responders`,
          as: Link,
        }
      : null,
    {
      title: 'Documentation',
      description: 'Everything you need to get building.',
      icon: 'article',
      href: `https://docs.swiftsmsgateway.com`,
      external: true,
    },
  ];

  return (
    <Card title="Quicklinks" description="Get started on building something great.">
      <QuickLinks links={links} />
    </Card>
  );
};

export default HomeQuickLinks;
